require('./style.scss')
angular = require('angular')
class FirewallTest
  @$inject: ["$uibModal"]
  constructor: (@modal)->
  open: (options)->
    template = require("./index.pug")
    instance = @modal.open
      template: template
      controller: require('./controller.coffee')             
      controllerAs: '$ctrl'
      backdrop: options.backdrop
      resolve: 
        options: ()->
          return options?={}
    
    return instance.result


pkg = angular
  .module 'device.firewall.test.modal', []
  .service "firewallTest", FirewallTest
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/component/device/firewall-test/index.coffee